



















































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import VideoPlayer from '@/common/vue/VideoPlayer.vue';
import IntersectionDirective from '@/common/vue/intersection-directive';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const Co2Labeling = () => import('@/webcomponents/co2-labeling/Co2Labeling.vue');
const Headline = () => import('@/webcomponents/headline/Headline.vue');
const RelaunchButton = () => import('@/common/vue/RelaunchButton.vue');

export const VIDEO_PLAYBACK_ENDED_EVENT = 'video-playback-ended';
const CLASS_HIDE_CTA_STRAP = 'brandhub-hide-cta-strap';
const CLASS_HIDE_CUSTOM_MENU_BAR = 'brandhub-hide-custom-menu-bar';
const SELECTOR_HEADER_PLACEHOLDER = '.brandhub-header-placeholder';
const CLASS_HEADER_PLACEHOLDER_HAS_CUSTOM_MENU_BAR = 'brandhub-header-placeholder--has-custom-menu-bar';

const FullscreenStageProps = Vue.extend({
  props: {
    editMode: Boolean,
    sectionTitle: String,
    text: String,
    headline: String,
    isTitleBig: Boolean,
    imageSources: String,
    pictureJson: String,
    desktopVideo: String,
    tabletVideo: String,
    mobileVideo: String,
    labelingJson: String,
    videoLoop: Boolean,
    linkText: String,
    linkUrl: String,
    linkTarget: String,
    textColor: {
      type: String,
      default: 'inverted',
    },
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
  components: {
    Headline,
    VideoPlayer,
    Co2Labeling,
    RelaunchButton,
  },
})
export default class FullscreenStage extends mixins(FullscreenStageProps, ResizeUpdateMixin) {
  $refs!: {
    video: VideoPlayer;
  }

  observerOptions = {
    rootMargin: '0px',
  }

  rememberIntersecting = false;
  hasCustomMenuBar = window.document.body.querySelector('.brandhub-custom-menu-bar');

  mounted () {
    if (this.windowWidth < 768) {
      this.hideCtaStrapCustomMenuBar(true);
    }
    this.$on('resize', this.onResize);
  }

  get rootClasses () {
    return {
      'brandhub-fullscreen-stage--primary': this.textColor === 'primary',
      'brandhub-fullscreen-stage--inverted': this.textColor === 'inverted',
      'brandhub-fullscreen-stage--theme': this.textColor === 'theme',
      'brandhub-fullscreen-stage--has-custom-menu-bar': this.hasCustomMenuBar,
      'brandhub-fullscreen-stage--edit-mode': this.editMode,
    };
  }

  get headlineColor (): string {
    let color = '';
    if (this.textColor === 'primary') {
      color = 'black';
    } else if (this.textColor === 'inverted') {
      color = 'white';
    } else if (this.textColor === 'theme') {
      color = 'theme';
    }
    return color;
  }

  hideCtaStrapCustomMenuBar (initial = false) {
    if (this.windowWidth < 768) {
      // this should be replaced with an eventbus after the migration of the custom menu bar and CTA strap to webcomponents
      window.document.body.classList.add(CLASS_HIDE_CUSTOM_MENU_BAR);
      const placeholder = window.document.body.querySelector(SELECTOR_HEADER_PLACEHOLDER);
      if (placeholder !== null) {
        placeholder.classList.remove(CLASS_HEADER_PLACEHOLDER_HAS_CUSTOM_MENU_BAR);
      }
      if (initial) {
        setTimeout(() => { // this timeout is needed because of logic of cta strap, that hides the cta strap forever when set to early
          window.document.body.classList.add(CLASS_HIDE_CTA_STRAP);
        }, 500);
      } else {
        window.document.body.classList.add(CLASS_HIDE_CTA_STRAP);
      }
    }
  }

  showCtaStrapCustomMenuBar () {
    // this should be replaced with an eventbus after the migration of the custom menu bar and CTA strap to webcomponents
    window.document.body.classList.remove(CLASS_HIDE_CUSTOM_MENU_BAR);
    const placeholder = window.document.body.querySelector(SELECTOR_HEADER_PLACEHOLDER);
    if (placeholder !== null && this.hasCustomMenuBar) {
      placeholder.classList.add(CLASS_HEADER_PLACEHOLDER_HAS_CUSTOM_MENU_BAR);
    }
    window.document.body.classList.remove(CLASS_HIDE_CTA_STRAP);
  }

  handleStageIntersect (isIntersecting: boolean) {
    if (!isIntersecting) {
      this.showCtaStrapCustomMenuBar();
      this.rememberIntersecting = isIntersecting;
    } else if (isIntersecting) {
      if (this.windowWidth < 768) {
        this.hideCtaStrapCustomMenuBar();
      } else {
        this.showCtaStrapCustomMenuBar();
      }
      this.rememberIntersecting = isIntersecting;
    }
  }

  onPlaybackEnded () {
    this.$emit(VIDEO_PLAYBACK_ENDED_EVENT);
  }

  onButtonClick () {
    if (this.linkText) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Fullscreen Stage', this.linkText, this.linkUrl);
    }
  }

  play () {
    this.$refs.video.play();
  }

  private onResize () {
    this.handleStageIntersect(this.rememberIntersecting);
  }
}
